import ApiClient from './ApiClient'

class ResourcesService {
  static getResource(ensembleId, resourceId) {
    return ApiClient.get(`/ensembles/${ensembleId}/resources/${resourceId}.json`)
  }

  static updateResource(ensembleId, resourceId, formData) {
    return ApiClient.patchFormData(`/ensembles/${ensembleId}/resources/${resourceId}.json`, formData)
  }

  static createResource(ensembleId, formData) {
    return ApiClient.postFormData(`/ensembles/${ensembleId}/resources.json`, formData)
  }

  static getNewResource(ensembleId) {
    return ApiClient.get(`/ensembles/${ensembleId}/resources/new.json`)
  }
}

export default ResourcesService